export class TaskStatus{
    id:number;
    taskId:number;
    createdBy:number;
    createdDate:Date;
    updatedBy:number;
}